module.exports = __webpack_public_path__ + "static/bajka-o-šeširu-koji-je-imao-čovjeka-3c0751bb5c6cc6c08ed42fc4a23bb483.png";